document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('register-form');
    if (form) {
        form.addEventListener('submit', function() {
            const button = document.getElementById('proceed-button');
            if (button) {
                button.dataset.origMessage = button.value;
                button.value = button.dataset.waitMessage;
                button.disabled = true;
            }
        }, { once: true });
    }
});